// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1vFXt","content":"GlobalSearch_content__3zi3V"};